var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapBlock',{staticStyle:{"width":"100%","height":"100%","position":"relative"},attrs:{"zoom":_vm.zoom,"markers":_vm.markers,"fitness":_vm.fitness}})}
var staticRenderFns = []

export { render, staticRenderFns }